import { login, register } from '@/services/ant-design-pro/api';

import {
  buildCurrentUserFromMockSession,
  clearMockAccountSession,
  frontendMockLogin,
  frontendMockRegister,
  getMockAccountSession,
} from './frontendMockAccountAuth';

export { getMockAccountSession } from './frontendMockAccountAuth';

/**
 * 是否使用纯前端模拟登录/注册（localStorage）。
 * 默认关闭：本地 `yarn start` 经 proxy 走线上/联调真实接口；需要离线账号时用 `yarn start:mock` 或 REACT_APP_USE_FRONTEND_MOCK_AUTH=true。
 */
export function isUseFrontendMockAccountAuth(): boolean {
  return process.env.REACT_APP_USE_FRONTEND_MOCK_AUTH === 'true';
}

export async function accountLogin(body: API.LoginParams, options?: { [key: string]: any }) {
  if (isUseFrontendMockAccountAuth()) {
    return frontendMockLogin(body);
  }
  return login(body, options);
}

export async function accountRegister(body: API.RegisterParams, options?: { [key: string]: any }) {
  if (isUseFrontendMockAccountAuth()) {
    return frontendMockRegister(body);
  }
  return register(body, options);
}

export function tryGetCurrentUserFromMockSession(): API.CurrentUser | undefined {
  if (!isUseFrontendMockAccountAuth()) return undefined;
  const session = getMockAccountSession();
  if (!session) return undefined;
  return buildCurrentUserFromMockSession(session);
}

export function clearAccountAuthSessionIfMock() {
  if (isUseFrontendMockAccountAuth()) {
    clearMockAccountSession();
  }
}
